module.exports = __webpack_public_path__ + "files/724c2e91123a95554396e6e1918c676b.gif";